import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Small, selective "?" affordance for genuinely non-obvious features.
// Opens a short plain-English explainer (what it is + why it matters + optional steps).
export function InfoHint({ title, children, steps, align = "end", label = "What is this?" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="info-hint" aria-label={label}
          className="h-7 w-7 rounded-full flex items-center justify-center text-ink-400 hover:text-ink hover:bg-sand-100 transition-colors">
          <Info className="h-4 w-4" strokeWidth={1.75} />
        </button>
      </PopoverTrigger>
      <PopoverContent align={align} className="w-80 p-4 rounded-2xl">
        {title && <div className="font-heading font-extrabold text-sm mb-1">{title}</div>}
        {children && <p className="text-sm text-ink-700 leading-relaxed">{children}</p>}
        {steps?.length > 0 && (
          <ol className="mt-3 space-y-1.5">
            {steps.map((s, i) => (
              <li key={i} className="flex gap-2 text-sm text-ink-700">
                <span className="shrink-0 h-5 w-5 rounded-full bg-ink text-white text-[11px] font-bold flex items-center justify-center">{i + 1}</span>
                <span>{s}</span>
              </li>
            ))}
          </ol>
        )}
      </PopoverContent>
    </Popover>
  );
}
